import I18n from 'i18n.js.erb'
import { displayTranslations, parseBlueprintImageNameAndEdition, titleize } from "../../utils/utils";
import PlaceholderImage from "./PlaceholderImage";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import IconTooltip from "./IconTooltip";
import React from "react";
import TextOverlayOnImage from "./TextOverlayOnImage";

const BlueprintImageListItem = ({
      logged_in_user,
      blueprintImage,
      checkFilters,
      onCheckHandler,
      onKeyDownQuantity,
      onChangeQuantity,
      displayVariantsHandler,
      modalOpened,
      atLeastOneVariantChecked,
      handleNavigation,
      gameName,
      i,
      blueprintImageMediumImageUrl
    }) => {

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)

  const medium_image_url = blueprintImageMediumImageUrl ? blueprintImageMediumImageUrl(blueprintImage) : blueprintImage.medium_image_url

  return checkFilters(blueprintImage) ? (
      <tr className={`${blueprintImage.checked === true && 'sealed-table-selected-row'}`}>
        <td className="text-center">
          <div className="d-flex justify-content-center position-relative text-center mt-4 mb-4 ml-4"
               style={{ width: '100px', height: '150px' }}>
            {
              medium_image_url ?
                <React.Fragment>
                  <img
                    className={!blueprintImage.variants ||
                    blueprintImage.variants.length === 0 ||
                    modalOpened
                      ? 'image-card-list shadow'
                      : 'image-card-list shadow deck-shadow'}
                    src={medium_image_url}
                    alt=""
                    onClick={(e) => displayVariantsHandler(e, i)}
                  />

                  {
                    !blueprintImage.encasing_id &&
                      <TextOverlayOnImage
                        textOverlay={I18n.t('js.common.notGradableProduct')}
                        size={'thumb'}
                        type={'red-overlay'}
                      />
                  }
                </React.Fragment>
                :
                <PlaceholderImage
                  size={'medium'}
                  overlaySize={'thumb'}
                  additionalClasses={
                    !blueprintImage.variants || blueprintImage.variants.length === 0 || modalOpened ?
                      "image-card-list shadow rounded mt-4 mb-4"
                      :
                      "image-card-list shadow rounded deck-shadow mt-4 mb-4"
                  }
                  showNotGradableProductOverlay={!blueprintImage.encasing_id}
                />
            }
          </div>
        </td>
        <td className="text-center">
          {blueprintImageNames.length > 1 ? (
            <div className="text-dark noselect">
              <p>
                {
                  parseBlueprintImageNameAndEdition(gameName, blueprintImage.edition, blueprintImageNames[0], 'singles')
                }
              </p>
              <p className="d-none d-md-block">
                {blueprintImageNames[1]}
              </p>
            </div>
          ) : (
            <div className="text-dark noselect d-none d-md-block">
              <p className="mr-3">
                {
                  blueprintImageNames[0] +
                  (blueprintImage.game_name !== 'Pokémon' && blueprintImage.edition &&
                  blueprintImage.en_name.toLowerCase().indexOf(blueprintImage.edition.toString().toLowerCase() === '1 edition' ? (blueprintImage.language === 'en' ? '1st edition' : '1a edizione') : blueprintImage.edition.toString().toLowerCase()) === -1 &&
                  !['', 'undefined'].includes(blueprintImage.edition.toString().toLowerCase()) ? ' - ' + blueprintImage.edition : '')
                }
              </p>
            </div>
          )}
          <p className="mr-3">{blueprintImage.collector_number}</p>
        </td>
        <td className="text-center">
          <div className="d-block">
            {blueprintImage.rarity_logo_url ? (
              <div className="w-75 m-auto text-center">
                <p>{titleize(blueprintImage.rarity)}</p>
                <img
                  className="d-none d-md-block m-auto"
                  style={{height: "20px", width: "20px"}}
                  src={blueprintImage.rarity_logo_url}
                  alt=""
                />
              </div>
            ) : (
              <p>
                { titleize(blueprintImage.rarity) }
              </p>
            )}
            <p className="mt-3">
              { titleize(blueprintImage.version) }
            </p>
          </div>
        </td>

        <td className="text-center max-w-250px-imp">
          {
            !blueprintImage.variants || blueprintImage.variants.length === 0 ?
              <div className="card-number noselect quantity-content p-2 ml-3 ">

                <div className="noselect">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                      </Tooltip>
                    }
                  >
                    <div>
                      <input
                        className="form-control quantity-name m-auto"
                        value={blueprintImage.quantity ? blueprintImage.quantity : ''}
                        name="bluprint_image_quantity"
                        type="number"
                        disabled={!logged_in_user || !blueprintImage.checked}
                        style={{width: "150px"}}
                        onKeyDown={(e) => onKeyDownQuantity(e)}
                        onChange={(e) => onChangeQuantity(e, i)}
                        data-id={blueprintImage.id}/>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
              :
              <p>{I18n.t('js.indexCardPage.tableLayout.onpenVariantsModal')}</p>
          }
        </td>

        <td>
          {!blueprintImage.variants || blueprintImage.variants.length === 0 ? (
            <div className="d-flex flex-wrap justify-content-center w-100">
              <button
                className="btn btn-dark text-light btn-sm rounded noselect align-self-center w-100"
                onClick={(e) => handleNavigation(e, blueprintImage, `/blueprint_images/${blueprintImage.id}`)}>
                {I18n.t('js.indexCardPage.cardInfo')}
              </button>
            </div>
          ) : (
            <div className="d-flex flex-wrap justify-content-center w-100">
              <a className="btn btn-dark text-light btn-sm rounded noselect align-self-center w-100"
                 onClick={(e) => displayVariantsHandler(e, i)}>
                {I18n.t('js.indexCardPage.btnOpenVariantsShow')}&nbsp;{blueprintImage.variants.length + 1}&nbsp;{I18n.t('js.indexCardPage.btnOpenVariantsCard')}
              </a>
            </div>
          )}
        </td>

        <td className="text-center">
          {/*All'utente devo comunicare se un prodotto è nella sua wishlist oppure no, ovvio solo nel caso in cui sia loggato.
        Qui non inserisco il controllo sul login in quanto già blueprintImage.already_in_wishlist mi indica se l'utente è loggato o meno:
        infatti se l'utente non è loggato non ho neppure il riferimento (id) alla wishlist, e la conseguenza di ciò è che blueprintImage.already_in_wishlist
        abbia valore 0 che è quello di default.*/}
          {blueprintImage.already_in_wishlist > 0 &&
          <p className="w-100 mt-10px mb-0"
            // style={{ fontSize: "0.7rem"}}
          >
            {I18n.t('js.common.thisCardIn')}&nbsp;
            <a
              href={`/wishlists/${blueprintImage.already_in_wishlist}/edit`}
              className="data-structure-link"
              style={{color: "inherit"}}>
              {I18n.t('js.common.yourWishlist')}
            </a>
          </p>
          }
        </td>

        <td className="pl-4 pr-4 text-center">
          {
            blueprintImage.encasing_id &&
              <input type="checkbox"
                     checked={blueprintImage.checked || (atLeastOneVariantChecked(blueprintImage))}
                     id={blueprintImage.id}
                     onChange={(e) => {
                       onCheckHandler(e, blueprintImage.id)
                     }}
                     className="checkbox sealed-table-checkbox ml-10px-imp mr-10px"
              />
          }
        </td>

      </tr>

    )
    : (<React.Fragment></React.Fragment>)
};

export default BlueprintImageListItem;